import { t } from 'i18next';
import React, { lazy, useEffect, useState } from 'react';
import Stories from 'react-insta-stories';
import Spinner from '../../common/loaders/spinner';
import BottomStaticFields from './bottomStaticFields';
import DiscountDetails from './discountDetails';
import { getSessionItem, setSessionItem } from '../../../webStorage/sessionStorage';
import { LANGUAGE_ENUMS } from '../../../functions/getCountryCode';
import SuspenseWrapper from '../../common/suspenseWrapper';
import {
  CHANGE_LANGUAGE,
  CHANGE_LANGUAGE_DEFAULT,
  LANGUAGE_ELLIPSE,
} from '../../../paths/defaultImage';
import { useTranslation } from 'react-i18next';
import useMountTransition from '../../../functions/customHooks/useMountTransition';
import LazyImage from '../../common/lazyLoad';

const ChangeLanguagePopup = lazy(() =>
  import(/* webpackChunkName:"ChangeLanguagePopup"*/ '../../popUp/changeLanguagePopup')
);

const Promotion = ({ promotions, showMenuHandler }) => {
  const [stories, setStories] = useState([]);
  const [bottomImages, setBottomImages] = useState([]);
  const STORY_DURATION = 3000;
  const PAUSE_DURATION = 200;
  const selectedLanguage = getSessionItem('i18nextLng') || 'en';
  const isSelectedLanguageEng = selectedLanguage === LANGUAGE_ENUMS['en'].languageCode;
  const [showChangeLanguage, setShowChangeLanguage] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const hasTransitionedIn = useMountTransition(showTooltip, 500);
  const { t } = useTranslation();

  useEffect(() => {
    if (getSessionItem('showLanguageTooltip')) return;
    setTimeout(() => setShowTooltip(true), 1500);
    setTimeout(() => {
      setShowTooltip(false);
      setSessionItem('showLanguageTooltip', true);
    }, 6500);
  }, []);

  useEffect(() => {
    const extractUrls = promotions
      .filter(
        (item) => item?.template?.img || item?.text1 || item?.text2 || item?.text3 || item?.text4
      )
      .map((item) => {
        return {
          url: item?.template?.img,
          duration: STORY_DURATION,
          seeMoreCollapsed: () => <DiscountDetails item={item} />,
          seeMore: () => '',
        };
      });
    setStories(extractUrls);
    let extractBottomImages = [];
    promotions.forEach((item) => {
      //Find availabel image url
      if (!extractBottomImages[0] && item.template?.bottom?.img1)
        extractBottomImages[0] = { src: item.template.bottom.img1, text: t('add_to_cart') };
      if (!extractBottomImages[1] && item.template?.bottom?.img2)
        extractBottomImages[1] = { src: item.template.bottom.img2, text: t('login') };
      if (!extractBottomImages[2] && item.template?.bottom?.img3)
        extractBottomImages[2] = { src: item.template.bottom.img3, text: t('place_order') };
    });
    setBottomImages(extractBottomImages);
  }, [promotions, selectedLanguage]);
  const [isPaused, setIsPaused] = useState(false);
  const storyEndHandler = () => {
    if (stories.length === 1) return;
    setIsPaused(true);
    setTimeout(() => {
      setIsPaused(false);
    }, [PAUSE_DURATION]);
  };

  return (
    <>
      {bottomImages.length > 0 && (
        <div
          className='promotion d-flex flex-column gap-3'
          style={{ maxHeight: `${window.innerHeight}px` }}>
          <div style={{ height: '60%' }} className='storyRapper'>
            {stories.length > 0 && (
              <Stories
                height='100%'
                width='100%'
                stories={stories}
                loop={true}
                isPaused={isPaused}
                onStoryEnd={storyEndHandler}
                storyStyles={{ height: '100%', width: '100%' }}
                storyContainerStyles={{
                  backgroundColor: 'white',
                  pointerEvents: stories.length !== 1 ? 'all' : 'none',
                }}
                loader={<Spinner />}
              />
            )}
          </div>
          {bottomImages.length > 0 && (
            <BottomStaticFields images={bottomImages} showMenuHandler={showMenuHandler} />
          )}
          <div
            className={`promotion-header__language ${isSelectedLanguageEng ? '' : 'not-eng'}`}
            onClick={() => setShowChangeLanguage(true)}>
            <LazyImage
              className={`promotion-header__language-img ${isSelectedLanguageEng ? '' : 'not-eng'}`}
              alt='language'
              src={isSelectedLanguageEng ? CHANGE_LANGUAGE_DEFAULT : CHANGE_LANGUAGE}
            />
            {isSelectedLanguageEng ? '' : LANGUAGE_ENUMS[selectedLanguage].name}
            {(showTooltip || hasTransitionedIn) && (
              <>
                <div className='arrow'></div>
                <div
                  className={`tooltip__container ${hasTransitionedIn ? 'in' : ''} ${
                    showTooltip ? 'visible' : ''
                  }`}>
                  <LazyImage
                    alt='language_ellipse'
                    src={LANGUAGE_ELLIPSE}
                    height={28}
                    width={28}></LazyImage>
                  Change your language here<br></br>
                  Ubah bahasa Anda di sini
                </div>
              </>
            )}
          </div>
          {showChangeLanguage && (
            <SuspenseWrapper>
              <ChangeLanguagePopup close={() => setShowChangeLanguage(false)} />
            </SuspenseWrapper>
          )}
        </div>
      )}
    </>
  );
};

export default Promotion;
